/**
 * Remove all characters that are not [-0-9.,+()" "]
 * same logic as in selectors.ui.isValidPhone
 */
export const filterPhoneValue = (value: string) => value.replace(/[^-0-9.,+()" "]/g, '');
